import { request } from "../../helpers/requestHelper";
import { returnMsg } from "../../helpers/shop/paymentHelper";
import { retryPayment } from './retryPayment';
import { htmlMsg, msg as swalMsg } from "../swal_msg";

import { CUSTOMER_EMAIL, SUPPORT_NUMBER_VIEW } from "../../constants/constants";
const MSG1 = `No se pudo registrar el pedido. Comuníquese con nosotros: ${SUPPORT_NUMBER_VIEW}`;

// registrar pedido con PayPal
export const paypalOrder = async (model) => {
    try {
        const resp = await request('payment/paypal/generate-order', model, 'POST');
        const body = await resp.json();
        if (body.status) return body;
        else return returnMsg(body, 'PayPal', model);
    } catch (err) {
        swalMsg('error', 'Checkout', MSG1);
        return { status: false };
    };
};

// registrar pedido con PayPal (intento sin promociones expiradas)
export const paypalOrderFn = async(model, cartData) => {
    try {
        const resp = await request('payment/paypal/generate-order', model, 'POST');
        const body = await resp.json();
        if (body.status)
            return { ...body, cartData: { ...cartData } };
        else
            return returnMsg(body, 'PayPal', model);
    } catch (err) {
        swalMsg('error', 'Checkout', MSG1);
        return { status: false, cartData: { ...cartData } };
    };
};

// actualizar pedido de PayPal (pago aprobado)
// ya no se utiliza desde que se movió la lógica a backend
export const confirmPaypalOrder = async(model) => {
    try {
        const resp = await request('payment/paypal/confirm-order', model, 'POST');
        const body = await resp.json();
        if (!body.status) {
            const { msg } = body;
            if (msg === 'miss')
                htmlMsg(
                    'warning', 'Checkout', `<h5>Falta información de su pedido</h5>
                    <h6>Asegúrese que el pago ha sido exitoso y comuníquese con nosotros al correo: ${CUSTOMER_EMAIL}</h6>`,
                    'Entendido'
                );
            else if (msg === 'not-found')
                htmlMsg(
                    'warning', 'Checkout', `<h5>No hemos podido encontrar su pedido</h5>
                    <h6>Asegúrese que el pago ha sido exitoso y comuníquese con nosotros al correo: ${CUSTOMER_EMAIL}</h6>`,
                    'Entendido'
                );
            else if (msg === 'server-err')
                htmlMsg(
                    'warning', 'Checkout', `<h5>Incidente al actualizar su pedido</h5>
                    <h6>Asegúrese que el pago ha sido exitoso y comuníquese con nosotros al correo: ${CUSTOMER_EMAIL}</h6>`,
                    'Entendido'
                );
            else
                htmlMsg(
                    'warning', 'Checkout', `<h5>Pedido no actualizado</h5>
                    <h6>Asegúrese que el pago ha sido exitoso y comuníquese con nosotros al correo: ${CUSTOMER_EMAIL}</h6>`,
                    'Entendido'
                );
        }
        return { status: true };
    } catch (err) {
        htmlMsg(
            'error', 'Checkout', `<h5>No se pudo actualizar el pedido</h5>
            <h6>Asegúrese que el pago ha sido exitoso y comuníquese con nosotros al correo: ${CUSTOMER_EMAIL}</h6>`,
            'Entendido'
        );
        return { status: true };
    };
};

// actualizar pedido con ID de PayPal (pedido en PayPal fue generado)
// ya no se utiliza desde que se movió la lógica a backend
export const updatePaypalOrder = async(model) => {
    try {
        await request('payment/paypal/update-order',
            model,
        'POST');
    } catch (err) {
        htmlMsg(
            'error', 'Checkout', `<h5>No se pudo actualizar el pedido</h5>
            <h6>Asegúrese que el pago ha sido exitoso y comuníquese con nosotros al correo: ${CUSTOMER_EMAIL}</h6>`,
            'Entendido'
        );
    };
};

// actualizar pedido con error de PayPal (pedido en PayPal no pudo ser generado)
export const attachPaypalError = async(model) => {
    try {
        await request('payment/paypal/order-error',
            model,
        'POST');
    } catch (err) {
        htmlMsg(
            'error', 'Checkout', `<h5>No se pudo actualizar el pedido</h5>
            <h6>Asegúrese que el pago ha sido exitoso y comuníquese con nosotros al correo: ${CUSTOMER_EMAIL}</h6>`,
            'Entendido'
        );
    };
};

// otbener enlace de pago con PayPal
// nuevo intento de pago (pedido ya registrado)
export const paypalPayment = (_id, setDisabled) => {
    return retryPayment('PayPal', _id, setDisabled);
};
